<template>
  <v-carousel v-if="items.length > 0">
    <v-carousel-item v-for="(item,i) in items" :key="i" :src="item"></v-carousel-item>
  </v-carousel>
</template>

<script>
export default {
  props: ["items"]
};
</script>

<style lang="sass" scoped>

</style>